<template>
    <tr>
        <td class="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
            <div class="inline-flex items-center gap-x-3">
                <span>#{{ props.articulo.COD_PROVEEDOR }}</span>
            </div>
        </td>
        <td class="px-4 py-4 text-sm text-gray-700 whitespace-nowrap">
            {{ props.articulo.agru_1_descrip }}
        </td>
        <td class="px-4 py-4 text-sm font-medium text-gray-700 whitespace-nowrap">
            <div>
                <p class="text-sm font-normal">{{ props.articulo.descrip_arti }}</p>
            </div>
        </td>

        <!-- {{ props.articulo.cantidad }} -->
        <td class="px-4 py-4 text-sm whitespace-nowrap">
            <div class="flex items-center justify-evenly gap-x-6">
                <div class="flex items-center space-x-3">

                    <button @click="restQuantity"
                        :class="['w-8 h-8 text-gray-700 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200',
                                 { 'pointer-events-none opacity-50': hasValidService }]">
                        -
                    </button>

                    <p class="text-gray-700 font-bold">{{ quantityValue }}</p>


                    <button @click="sumQuantity"
                        :class="['w-8 h-8 text-gray-700 bg-gray-100 rounded-lg flex items-center justify-center hover:bg-gray-200', 
                                { 'pointer-events-none opacity-50': hasValidService }]">
                        +
                    </button>
                </div>

                <button @click="deleteProduct" 
                        :class="['text-blue-500 transition-colors duration-200 hover:text-indigo-500 focus:outline-none', 
                                { 'pointer-events-none opacity-50': hasValidService }]">
                    <span>Eliminar</span>
                </button>
            </div>
        </td>


    </tr>
</template>

<script setup lang="ts">

import { computed } from 'vue';
import type { ArticuloOrden } from '../../interface';
import { useOrderStore } from './store/Order.store';
import { useOrderDetail } from '../OrderShipmentData/store/OrderShipmentData.store';

const props = defineProps<{
    articulo: ArticuloOrden
}>();

const calculatedStock = computed(() => props.articulo.canti_stock - props.articulo.canti_reser)

const quantityValue = computed(() => props.articulo.cantidad)

// Order  STORE/PINIA
const orderStore = useOrderStore()

const orderDetail = useOrderDetail()
const getAkeronService = computed(() => orderDetail.getAkeronService)


// Verificar si HAY un servicio válido
const hasValidService = computed(() => {
    return getAkeronService.value?.service && 
           getAkeronService.value.service.id !== 0 && 
           getAkeronService.value.service.name
})


const product = orderStore.getOrderArticles.find(product => product.cod_articulo === props.articulo.cod_articulo)


const sumQuantity = () => {
    if (product && product.cantidad < calculatedStock.value) {
        product.cantidad++;
    }
}

const restQuantity = () => {
    if (product && product.cantidad === 1) return;
    if(product) {
        product.cantidad--;
    }
}





// Eliminar producto de la orden
const deleteProduct = () => {
    const newProducts = orderStore.getOrderArticles.filter(product => product.cod_articulo !== props.articulo.cod_articulo)
    orderStore.updateOrderStore(newProducts)
}


</script>

<style scoped></style>